<div class="row">
  <div class="col-sm-12 col-md-6 col-md-offset-3 break-text" *ngIf="userWizardInfo !== null">
    <!-- Error Block -->
    <div class="error-container" aria-live="assertive">
      <div class="alert valign-children-middle" *ngIf='setError'>
        <div class="alert-error" aria-label="Alert.">
          <i class="icon-badgealert" aria-hidden="true"></i>
        </div>
        <div>
          <h2 *ngIf='!errorFlag'>Please note</h2>
          <h2 *ngIf='errorFlag'>Too many users selected</h2>
          <p>{{ErrorMessage}}</p>
        </div>
      </div>
    </div>
    <!-- Error Block End -->
    <div *ngIf='showProductInfo'>
      <div><label class="data-label">Selected product:</label> <span>{{ selectedProdDetails && selectedProdDetails.productName}}</span></div>
      <div><label class="data-label">Foundation account: </label> <span>{{ selectedProdDetails && selectedProdDetails.selectedFan}}</span></div>
      <div><label class="data-label">Wireless number: </label> <span>{{ selectedProdDetails && selectedProdDetails.selectedCtn}}</span></div>
      <div>{{ selectedProdDetails && selectedProdDetails.licensegroupName}}</div>
    </div>
    <div *ngIf='!showProductInfo'>
      <div><label class="data-label">Selected product:</label> <a href="javascript:void(0)" class="default-cursor">{{ noOfSelectedProduct }} products</a></div>
    </div>
    <hr class="dotted-border" />
    <label>Select up to {{this.checkLicense}} users to {{actionType}}</label>
    <p>You have {{this.checkLicense}} <span [innerHTML]="(this.checkLicense > 1)? 'licenses':'license'"></span> left and you selected {{totalUser}} users.</p>

    <app-customgrid [gridOptions]="gridOptions" (gridEvent)="gridEventChanges($event)" (checkboxSelections)="checkboxSelections($event)"
      (radioSelections)="radioSelections($event)"></app-customgrid>

     <p>You have {{this.checkLicense}} <span [innerHTML]="(this.checkLicense > 1)? 'licenses':'license'"></span> left and you selected {{totalUser}} users.</p> 
    <hr class="bottom-hr">
    <div class="line-footer text-right">
      <button aria-label="Continue." class="btn btn-secondary btn-sm-block pull-right" (click)='next()' [disabled]='continueDisable'>Continue</button>
      <a href="javascript:void(0)" class="btn btn-sm-block btn-link" (click)="back()">Back</a>
    </div>
  </div>
</div>